import { render, staticRenderFns } from "./PriceBlock.vue?vue&type=template&id=66bdba18"
import script from "./PriceBlock.vue?vue&type=script&lang=js"
export * from "./PriceBlock.vue?vue&type=script&lang=js"
import style0 from "./PriceBlock.vue?vue&type=style&index=0&id=66bdba18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports